<template>
    <Modal v-model="show"
        :width="80"
        :footer-hide="true"
        title="质检不合格通知书明细"
        class-name="vertical-center-modal"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">

            <Row :gutter="16">
                <Col span="24">
                <Form label-position="top"
                    class="small-form">
                    <Row :gutter="16">
                        <Col span="3">
                        <FormItem label="转运站">
                            <Input :value="record.distributionStationName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="苗场">
                            <Input :value="record.seedFarmName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="专家">
                            <Input :value="record.masterName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="苗场答复">
                            <Input :value="record.qualifyFailReportRecordSeedFarmResponse"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="专家答复">
                            <Input :value="record.qualifyFailReportRecordMasterResponse"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="提出时间">
                            <Input :value="formatDateTimeString( record.qualifyFailReportRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="苗场回复时限">
                            <Input :value="formatDateTimeString( record.qualifyFailReportRecordDelayedExpire)"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>

            <Row :gutter="16">
                <Form label-position="top"
                    class="small-form">
                    <template v-if="record.qualifyFailReportRecordSeedFarmResponse === '' && $checkAccessArray(['B', 'C'])">
                        <Col span="6">
                        <FormItem>
                            <div slot="label">苗场答复
                                <Button type="primary"
                                    @click="onSeedFarmResponse">提交</Button>
                            </div>
                            <RadioGroup v-model="seedFarmResponse">
                                <Radio label="同意">同意，退款</Radio>
                                <Radio label="不同意">不同意，申请仲裁</Radio>
                            </RadioGroup>
                        </FormItem>
                        </Col>
                    </template>

                    <template v-if="$checkAccessArray(['B', 'C'])">
                        <Col span="3">
                        <FormItem>
                            <div slot="label">延时回复
                                <Button :disabled="record.qualifyFailReportRecordUseDelayed !== 0"
                                    type="primary"
                                    @click="onApplyDelayed">提交</Button>
                            </div>
                            <Input :value="record.qualifyFailReportRecordUseDelayed === 0 ? '未申请' : '已申请'"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </template>
                </Form>
            </Row>

            <Row :gutter="16">
                <Form label-position="top"
                    class="small-form">
                    <template v-if="record.qualifyFailReportRecordSeedFarmResponse === '不同意' && record.qualifyFailReportRecordMasterResponse === '' && $checkAccessArray(['A'])">
                        <Col span="6">
                        <FormItem>
                            <div slot="label">专家答复
                                <Button type="primary"
                                    @click="onMasterResponse">提交</Button>
                            </div>
                            <RadioGroup v-model="masterResponse">
                                <Radio label="苗场退款">苗场责任，退款</Radio>
                                <Radio label="无需退款">无需退款</Radio>
                            </RadioGroup>
                        </FormItem>
                        </Col>
                    </template>
                </Form>
            </Row>

            <Row :gutter="16"
                class="row-margin-top-15">
                <Button :disabled="record.qualifyFailReportRecordImages === ''"
                    type="warning"
                    @click="loadCheckImage">查看质检图片</Button>
            </Row>

            <Row :gutter="16"
                class="row-margin-top-15"
                style="margin-top:20px;">
                <Col span="24">
                <b>质检产品</b>
                <Table ref="mainTable"
                    size="small"
                    :columns="mainTable.columns"
                    :data="details"
                    highlight-row
                    stripe
                    border />
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import { formatDateTimeString } from '@/libs/logic';
import { getImageSrc } from '@/libs/tableRowImageRender';

import {
    getQualifyFailReportDetail,
    qualifyFailReportApplyDelayed,
    qualifyFailReportMasterResponse,
    qualifyFailReportSeedFarmResponse
} from '@/api/modules/qualifyFail-report-management/qualifyFail-report';

export default {
    name: 'QualifyFailReportDetail',
    data() {
        return {
            show: false,
            innerSpin:false,
            orderUuid: '',
            qualifyFailReportRecordUuid: '',
            record: {
                distributionStationName: '',
                seedFarmName: '',
                masterName: '',
                qualifyFailReportRecordSeedFarmResponse: '',
                qualifyFailReportRecordMasterResponse: '',
                qualifyFailReportRecordUseDelayed: 0,
                qualifyFailReportRecordCreateAt: '',
                qualifyFailReportRecordDelayedExpire: '',
                qualifyFailReportRecordImages: ''
            },
            details: [],
            mainTable: {
                columns: [
                    { title: '产品', key: 'productName', align: 'center' },
                    { title: '产品编号', key: 'productCode', align: 'center' },
                    { title: '质检量', key: 'distributionStationProductCheckJournalTotalQuantity', align: 'center' },
                    { title: '质检问题数量', key: 'distributionStationProductCheckJournalQualifyFailQuantity', align: 'center' },
                    { title: '物流问题数量', key: 'distributionStationProductCheckJournalLogisticsFailQuantity', align: 'center' },
                    { title: '原因', key: 'distributionStationProductCheckJournalRemark', align: 'center' }
                ]
            },
            seedFarmResponse: '',
            masterResponse: ''
        };
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        formatDateTimeString,
        init() {
            if (this.orderUuid) {
                this.qualifyFailReportRecordUuid = this.orderUuid;
                this.innerSpin = true;
                getQualifyFailReportDetail(this.qualifyFailReportRecordUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.record = Object.assign(this.record, res.data);
                        this.details = res.data.qualifyFailReportDetails;
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }

        },
        onSeedFarmResponse() {
            if (this.seedFarmResponse === '') {
                this.$Modal.error({ title: '出错啦', content: '请先选择回复内容' });
                return;
            }

            const submitData = {
                qualifyFailReportRecordUuid: this.qualifyFailReportRecordUuid,
                qualifyFailReportRecordSeedFarmResponse: this.seedFarmResponse
            };

            this.innerSpin = true;
            qualifyFailReportSeedFarmResponse(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.$parent.init();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        onMasterResponse() {
            if (this.masterResponse === '') {
                this.$Modal.error({ title: '出错啦', content: '请先选择回复内容' });
                return;
            }

            const submitData = {
                qualifyFailReportRecordUuid: this.qualifyFailReportRecordUuid,
                qualifyFailReportRecordMasterResponse: this.masterResponse
            };

            this.innerSpin = true;
            qualifyFailReportMasterResponse(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        onApplyDelayed() {
            this.innerSpin = true;
            qualifyFailReportApplyDelayed(this.qualifyFailReportRecordUuid).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '申请成功',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        loadCheckImage() {
            const imageSrc = getImageSrc(this.record.qualifyFailReportRecordImages);
            if (imageSrc) {
                window.open(imageSrc);
            }
        }
    }
};
</script>

<style scoped>
</style>
